import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../App";
import {
  LayoutDashboard,
  Mail,
  Users,
  FileText,
  Globe,
  AlertTriangle,
  Shield,
  UserCheck,
  AlertCircle,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Target,
  UsersRound,
  Download,
  Library,
  Sparkles,
  Image
} from "lucide-react";
import culsightLogo from "../assests/Culsight Logo (1).png";
import culsightSmallLogo from "../assests/culsight_logo.jpg";

const Sidebar = ({ collapsed, onToggle }) => {
  const { logout, user } = useAuth();
  const location = useLocation();

  const menuItems = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard" },
    { icon: Target, label: "Campaigns", path: "/campaigns" },
    { icon: Users, label: "Users", path: "/users" },
    { icon: UsersRound, label: "User Groups", path: "/user-groups" },
    { icon: Mail, label: "Email Templates", path: "/email-templates" },
    { icon: Image, label: "Media", path: "/media" },
    { icon: Library, label: "Template Library", path: "/template-library" },
    { icon: Sparkles, label: "AI Studio", path: "/ai-studio" },
    { icon: Globe, label: "Landing Pages", path: "/landing-pages" },
    { icon: AlertTriangle, label: "Offenders", path: "/offenders" },
    { type: "divider", label: "Analytics" },
    { icon: Shield, label: "Department Heatmap", path: "/department-heatmap" },
    { icon: UserCheck, label: "Human Risk Scorecard", path: "/human-risk-scorecard" },
    { icon: AlertCircle, label: "Insider Risk", path: "/insider-risk" },
    { type: "divider", label: "Reports" },
    { icon: Download, label: "Downloads", path: "/downloads" },
    { type: "divider", label: "System" },
    { icon: Settings, label: "Settings", path: "/settings" },
  ];

  return (
    <aside
      className={`fixed left-0 top-0 h-full bg-white border-r border-gray-200 z-50 transition-all duration-300 ${collapsed ? "w-20" : "w-64"
        }`}
      data-testid="sidebar"
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-100">

        {!collapsed && (
          <div className="flex items-center justify-center">
            <img
              src={culsightLogo}
              alt="Culsight Logo"
              className="h-16 w-auto"
            />
          </div>
        )}

        {collapsed && (
          <img
            src={culsightSmallLogo}
            alt="Culsight Logo"
            className="h-8 w-8 mx-auto object-contain"
          />
        )}
        <button
          onClick={onToggle}
          className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          data-testid="sidebar-toggle"
        >
          {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="p-3 space-y-1 overflow-y-auto h-[calc(100vh-140px)]">
        {menuItems.map((item, index) => {
          if (item.type === "divider") {
            return (
              <div key={index} className="pt-4 pb-2">
                {!collapsed && (
                  <span className="px-3 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                    {item.label}
                  </span>
                )}
                {collapsed && <div className="border-t border-gray-200 mx-2" />}
              </div>
            );
          }

          const Icon = item.icon;
          const isActive = location.pathname === item.path ||
            (item.path === "/dashboard" && location.pathname === "/");

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 group ${isActive
                  ? "bg-[#8c3add]/10 text-[#8c3add] border-l-[3px] border-[#8c3add] -ml-[3px] pl-[calc(0.75rem+3px)]"
                  : "text-gray-600 hover:bg-gray-50 hover:text-[#8c3add]"
                }`}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Icon
                size={20}
                className={`flex-shrink-0 ${isActive ? "text-[#8c3add]" : "text-gray-500 group-hover:text-[#8c3add]"}`}
              />
              {!collapsed && (
                <span className="font-medium text-sm truncate">{item.label}</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* User & Logout */}
      <div className="absolute bottom-0 left-0 right-0 p-3 border-t border-gray-100 bg-white">
        <button
          onClick={logout}
          className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-gray-600 hover:bg-red-50 hover:text-red-600 transition-all ${collapsed ? "justify-center" : ""
            }`}
          data-testid="logout-button"
        >
          <LogOut size={20} />
          {!collapsed && <span className="font-medium text-sm">Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
